import React from 'react';
import { useSelector } from 'react-redux';
import { Box } from '@mui/system';
import DirectionsWalkIcon from '@mui/icons-material/DirectionsWalk';
import styles from './TakeOutOrderBox.style';
import useClasses from '../../../hooks/legacy/useClasses';

function TakeOutOrderBox() {
  const classes = useClasses(styles);

  const { restaurant } = useSelector(({ restaurant: selectedRestaurant }) => ({
    restaurant: selectedRestaurant?.selectedRestaurantData,
  }));
  return (
    <Box className={classes.takeoutBackground}>
      <Box className={classes.iconCenter}>
        <DirectionsWalkIcon color="secondary" />
      </Box>
      <Box className={classes.takeoutHeading}>This is a Takeout order.</Box>
      <Box className={classes.takeoutSubHeading}>
        {`Please go to ${restaurant?.name} to pick up this order.`}
      </Box>
    </Box>
  );
}

export default TakeOutOrderBox;
